export const validatePosition = (start: number, distance: number, point: number) => {
    if (start <= point && point <= start + distance) {
        return start;
    }
    return point;
};
